import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();

const base = '/api/v1/purple-post/replies';
const baseFailed = '/api/v1/purple-post/reply-failures';

export default {
  uploadReply(file) {
    return axios.post(`${base}/upload/`, file);
  },
  getFailedReplies(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${baseFailed}/prison${queryString}`);
  },
  getSingleFailedReply(id) {
    return axios.get(`${baseFailed}/single/${id}`);
  },
  bulkAcknowledgeReplies(ids) {
    return axios.post(`${baseFailed}/bulk-acknowledge`, ids);
  },
  linkFailedReply(replyId, qrCode) {
    return axios.post(`${baseFailed}/link-reply-to-post/${replyId}`, { qr_code_ref: qrCode });
  },
};
